import React, { useState } from 'react';
import './SpreadTheWord.css';

const SpreadTheWord = () => {
  const [copied, setCopied] = useState(false);
  
  const shareUrl = 'https://irelandvisatracker.in';
  const shareTitle = 'Irish Visa Tracker - Official Decision Monitoring';
  const shareText = 'Track official NDVO visa decisions with email alerts, optional browser notifications and 13 premium planning tools. INR 349 one-time for Indian applicants.';

  const socialPlatforms = [
    {
      name: 'Facebook',
      icon: '👥',
      color: '#1877F2',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      popular: false
    },
    {
      name: 'Twitter',
      icon: '🐦',
      color: '#1DA1F2',
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`
    },
    {
      name: 'LinkedIn',
      icon: '💼',
      color: '#0A66C2',
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`
    },
    {
      name: 'Telegram',
      icon: '✈️',
      color: '#0088cc',
      url: `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`
    },
    {
      name: 'Reddit',
      icon: '🤖',
      color: '#FF4500',
      url: `https://reddit.com/submit?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(shareTitle)}`
    }
  ];

  const handleShare = (url, name) => {
    window.open(url, '_blank', 'noopener,noreferrer,width=600,height=600');
    
    // Track share event
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'share', {
        method: name,
        content_type: 'website',
        item_id: shareUrl
      });
    }
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      console.error('Failed to copy link:', err);
    }
  };

  return (
    <div className="spread-the-word-section">
      <div className="spread-container">
        <div className="spread-header">
          <div className="spread-icon">💚</div>
          <h2>Help Us Spread the Word</h2>
          <p className="spread-subtitle">
            We're building this for every Indian visa applicant waiting anxiously for their decision. 
            If this service helped you—or could help someone you know—please share it with your friends, 
            family, or community groups.
          </p>
        </div>

        <div className="spread-stats">
          <div className="spread-stat">
            <div className="stat-icon">🙏</div>
            <div className="stat-content">
              <div className="stat-value">Share a resource</div>
              <div className="stat-label">Help another applicant</div>
            </div>
          </div>
          <div className="spread-stat">
            <div className="stat-icon">🌟</div>
            <div className="stat-content">
              <div className="stat-value">Every Share</div>
              <div className="stat-label">Helps fellow applicants</div>
            </div>
          </div>
        </div>

        <div className="spread-buttons">
          <h3>Share on your favorite platform:</h3>
          <div className="share-platforms-grid">
            {socialPlatforms.map((platform) => (
              <button
                key={platform.name}
                className={`share-platform-btn ${platform.popular ? 'popular' : ''}`}
                onClick={() => handleShare(platform.url, platform.name)}
                style={{ '--platform-color': platform.color }}
              >
                <span className="platform-icon">{platform.icon}</span>
                <span className="platform-name">{platform.name}</span>
                {platform.popular && <span className="popular-badge">Most Used</span>}
              </button>
            ))}
          </div>
        </div>

        <div className="copy-link-section">
          <div className="copy-link-container">
            <input
              type="text"
              value={shareUrl}
              readOnly
              className="copy-link-input"
              onClick={(e) => e.target.select()}
            />
            <button
              className={`copy-link-btn ${copied ? 'copied' : ''}`}
              onClick={handleCopyLink}
            >
              {copied ? '✓ Copied!' : '📋 Copy Link'}
            </button>
          </div>
          <p className="copy-link-hint">
            Or copy the link to share anywhere else
          </p>
        </div>

        <div className="spread-impact">
          <div className="impact-message">
            <span className="impact-icon">🎯</span>
            <p>
              <strong>Your share matters:</strong> Help another applicant find official-decision
              monitoring and practical resources for their visa journey.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpreadTheWord;
